import { render, staticRenderFns } from "./DeleteOrgDialog.vue?vue&type=template&id=6d7e1892&"
import script from "./DeleteOrgDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteOrgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports